import { render } from "./Adventures.vue?vue&type=template&id=1efd6be6"
import script from "./Adventures.vue?vue&type=script&lang=js"
export * from "./Adventures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/Adventures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1efd6be6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1efd6be6', __exports__)) {
    api.reload('1efd6be6', __exports__)
  }
  
  module.hot.accept("./Adventures.vue?vue&type=template&id=1efd6be6", () => {
    api.rerender('1efd6be6', render)
  })

}


export default __exports__